module.exports = __webpack_public_path__ + "static/media/cup-user-info.39f6c5e6.svg";